// import { HttpClient } from "@angular/common/http";
// import { Injectable } from "@angular/core";
// import { AssetInfo, DataProtection} from "@aptsi-types";
// import { environment } from "@env";
// import { Observable } from "rxjs";
// import { catchError, map } from "rxjs/operators";
// import { ErrorHandlingService } from "../shared/errorHandling/errorHandling.service";
// import { API_ENDPOINTS } from "../data-protection-api-endpoints";

// interface GetDataProtectionReport {
//   dataProtectionReport: AssetInfo[];
// }

// // interface VerifyAssets {
// //   verify: AssetInfo[];
// // }

// @Injectable({
//   providedIn: "root",
// })
// export class DataProtectionReportService {
//   private readonly dataProtectionUrl = environment.apiUrl;

//   constructor(
//     private http: HttpClient,
//     private errorHandlingService: ErrorHandlingService
//   ) {}
  
//   getDpReports(selectedFilter: string): Observable<AssetInfo[]> {
//     return this.http
//       .post<GetDataProtectionReport>(
//         `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.FETCH}`,
//         { selectedFilter }
//       )
//       .pipe(
//         map((response) => response.dataProtectionReport),
//         catchError((error) => this.errorHandlingService.handleError(error))
//       );
//   }

//     getDpDashboardChartData( selectedFilter: string): Observable<AssetInfo[]> {
//       return this.http
//         .post<GetDataProtectionReport>(
//           `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.FETCHCHARTDATA}`,
//           { selectedFilter}
//         )
//         .pipe(
//           map((response) => response.dataProtectionReport),
//           catchError((error) => this.errorHandlingService.handleError(error))
//         );
//     }


//     //  DataAssetsInventoryReport(selectedFilter: string): Observable<DataProtection[]> {
//     //   return this.http
//     //     .post<DataProtection[]>(
//     //       `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.DATA_ASSET_INVENTORY_REPORT}`,
//     //       { selectedFilter}
//     //     )
//     //     .pipe(
//     //       map((response) => response),
//     //       catchError((error) => this.errorHandlingService.handleError(error))
//     //     );
//     // }

//     //   ProtectionProgramStatusReport(selectedFilter: string): Observable<DataProtection[]> {
//     //   return this.http
//     //     .post<DataProtection[]>(
//     //       `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.PROTECTION_PROGRAM_STATUS_REPORT}`,
//     //       { selectedFilter}
//     //     )
//     //     .pipe(
//     //       map((response) => response),
//     //       catchError((error) => this.errorHandlingService.handleError(error))
//     //     );
//     // }

// }

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataProtection } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from '../shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from '../data-protection-api-endpoints';

export interface DataAssetInventoryItem extends Partial<DataProtection> {
  dataAssetId?: string | null;
  dataAssetName?: string | null;
  description?: string | null;
  classification?: string | null;
  mappingStatus?: string | null;
  systemAssets?: string[] | null;
  securityZones?: string[] | null;
  assetSourceId?: string | null;
  sourceSystem?: string | null;
  importedAt?: string | null;
  updatedAt?: string | null;
  systemAssetsDisplay?: string;
  securityZonesDisplay?: string;
}

export interface DataAssetsInventoryReportResponse extends Partial<DataProtection> {
  totalAssets?: number;
  mappedAssets?: number;
  unmappedAssets?: number;
  mappingCoveragePercent?: number;
  totalPages?: number;
  currentPage?: number;
  assets?: DataAssetInventoryItem[] | null;
}

export interface ProtectionProgramReportItem extends Partial<DataProtection> {
  programId?: string | null;
  programName?: string | null;
  programOwner?: string | null;
  dataAssetId?: string | null;
  dataAssetName?: string | null;
  startDate?: string | null;
  targetCompletionDate?: string | null;
  programStatus?: string | null;
  implementationStatus?: string | null;
  verificationStatus?: string | null;
  verificationDate?: string | null;
  overdue?: boolean | null;
  upcoming?: boolean | null;
  overdueDisplay?: string;
  upcomingDisplay?: string;
}

export interface ProtectionProgramStatusReportResponse extends Partial<DataProtection> {
  totalPrograms?: number;
  completedPrograms?: number;
  completionPercent?: number;
  overduePrograms?: number;
  upcomingPrograms?: number;
  programsByStatus?: Record<string, number> | null;
  totalPages?: number;
  currentPage?: number;
  programs?: ProtectionProgramReportItem[] | null;
}

export interface ProgramStatusDistribution {
  status: string;
  count: number;
}

export interface VerifiedCoverageByClassification {
  classification: string;
  verifiedAssets: number;
  totalEligibleAssets: number;
  coveragePercent: number;
}

export interface DataProtectionDashboardChartData extends Partial<DataProtection> {
  programStatusDistribution?: ProgramStatusDistribution[] | null;
  verifiedCoverageByClassification?: VerifiedCoverageByClassification[] | null;
}

@Injectable({ providedIn: 'root' })
export class DataProtectionReportService {
  private readonly dataProtectionUrl = environment.apiUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlingService: ErrorHandlingService,
  ) {}

  /** Fetch chart series used by the Data Protection dashboard and reports screen. */
  getDpDashboardChartData(selectedFilter: string): Observable<DataProtectionDashboardChartData> {
    return this.http
      .post<unknown>(
        `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.FETCHCHARTDATA}`,
        { selectedFilter },
      )
      .pipe(
        map((response) => this.extractPayload<DataProtectionDashboardChartData>(response)),
        catchError((error) => this.errorHandlingService.handleError(error)),
      );
  }

  /** Report data asset inventory, including mapping status and related resources. */
  DataAssetsInventoryReport(selectedFilter: string): Observable<DataAssetsInventoryReportResponse> {
    return this.http
      .post<unknown>(
        `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.DATA_ASSET_INVENTORY_REPORT}`,
        { selectedFilter },
      )
      .pipe(
        map((response) => this.extractPayload<DataAssetsInventoryReportResponse>(response)),
        catchError((error) => this.errorHandlingService.handleError(error)),
      );
  }

  /** Report protection-program and verification status. */
  ProtectionProgramStatusReport(selectedFilter: string): Observable<ProtectionProgramStatusReportResponse> {
    return this.http
      .post<unknown>(
        `${this.dataProtectionUrl}${API_ENDPOINTS.REPORTS.PROTECTION_PROGRAM_STATUS_REPORT}`,
        { selectedFilter },
      )
      .pipe(
        map((response) => this.extractPayload<ProtectionProgramStatusReportResponse>(response)),
        catchError((error) => this.errorHandlingService.handleError(error)),
      );
  }

  /**
   * The API may return the report directly, inside `dataProtectionReport`, or
   * as a one-item array. Normalize these shapes at the service boundary.
   */
  private extractPayload<T>(response: unknown): T {
    let payload: unknown = response;

    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
      const wrapper = payload as Record<string, unknown>;
      if (wrapper['dataProtectionReport'] !== undefined) {
        payload = wrapper['dataProtectionReport'];
      }
    }

    if (Array.isArray(payload)) {
      payload = payload[0] ?? {};
    }

    return (payload ?? {}) as T;
  }
}
